var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInUp", delay: 0, duration: 300 },
          expression: "{ classes: 'slideInUp', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-debug",
    },
    [
      _c("section", { staticClass: "header" }, [
        _c(
          "span",
          {
            staticClass: "material-icons text-info",
            staticStyle: { "font-size": "30px" },
          },
          [_vm._v("terminal")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c(
            "strong",
            {
              staticClass: "font-weight-bold",
              staticStyle: { "font-size": "18px", "letter-spacing": "1.2px" },
            },
            [_vm._v("Automation Test Tool")]
          ),
          _vm._v(" "),
          _c(
            "small",
            { staticClass: "text-success" },
            [
              _c("a-badge", { attrs: { color: "green" } }),
              _vm._v(
                "\n                Automation Debugger Active\n            "
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "md-button",
              { staticClass: "md-icon-button", on: { click: _vm.closeWidget } },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "steps" },
        _vm._l(_vm.steps, function (step) {
          return _c("TaskStepViewer", {
            key: step.order,
            attrs: { value: step },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "footer" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "", disabled: _vm.closed },
              on: { click: _vm.continueTest },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("play_arrow"),
              ]),
              _vm._v("\n            Continue Test\n            "),
              _c("div", { staticClass: "key" }, [
                _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { "data-v-63a309c6": "" },
                  },
                  [_vm._v("CMD")]
                ),
                _vm._v("\n                +\n                "),
                _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { "data-v-63a309c6": "" },
                  },
                  [_vm._v("→")]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.closed
            ? _c(
                "SupsisButton",
                { attrs: { ghost: "" }, on: { click: _vm.startTest } },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("play_arrow"),
                  ]),
                  _vm._v("\n            Start new Test\n            "),
                  _c("div", { staticClass: "key" }, [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        attrs: { "data-v-63a309c6": "" },
                      },
                      [_vm._v("CMD")]
                    ),
                    _vm._v("\n                +\n                "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary",
                        attrs: { "data-v-63a309c6": "" },
                      },
                      [_vm._v("ENTER")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }